import type { StateCreator } from 'zustand';
import { create } from 'zustand';

type CommunityHistoryStore = {
  visitedSlugs: string[];
  addVisitedSlug: (slug: string) => void;
  removeLastVisitedSlug: () => void;
  getLastVisited: () => string | undefined;
};

const storeCreator: StateCreator<CommunityHistoryStore> = (set, get) => ({
  visitedSlugs: [],

  addVisitedSlug: (slug: string) => {
    const { visitedSlugs } = get();
    if (visitedSlugs[visitedSlugs.length - 1] !== slug) {
      set({ visitedSlugs: [...visitedSlugs, slug] });
    }
  },

  removeLastVisitedSlug: () => {
    const { visitedSlugs } = get();
    if (visitedSlugs.length > 0) {
      const newSlugs = visitedSlugs.slice(0, visitedSlugs.length - 1);
      set({ visitedSlugs: newSlugs });
    }
  },

  getLastVisited: () => {
    const { visitedSlugs } = get();
    return visitedSlugs[visitedSlugs.length - 1];
  },
});

export const useCommunityHistoryStore =
  create<CommunityHistoryStore>(storeCreator);
